import {loadStripe} from '@stripe/stripe-js/pure';
import {User} from "@/lib/api";

export const stripePromise = loadStripe(
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
);

export const hostedCheckout = (priceId: string, user: User) => {
    if (!user.paddle_customer_id) {
        throw new Error('Paddle Customer ID is not defined');
    }

    if (!user.hostedCheckoutUrl) {
        throw new Error('Paddle Hosted Checkout URL is not defined');
    }
    const params = new URLSearchParams({
        price_id: priceId,
        paddle_customer_id: user.paddle_customer_id,
    });
    
    window.location.replace(`${user.hostedCheckoutUrl}?${params.toString()}`);
}